module.exports = __webpack_public_path__ + "static/media/pencil.5c459d05.svg";